/*eslint-env browser*/


function urlParams (url, mode) {
    if (url === "#" || url === "all") {
        mode = url
        url = false
    }

    if (!url) {
        url = document.location.href
    }

    url  = betterDecodeUri(url)
    mode = mode || "params"

    return urlParamsStrict(url, mode)
}


function urlParamsStrict (url, mode) {
    let result = {}

    let splitted = split(url)

    if (includeParams(mode)) {
        addParamsFromString(result, splitted.regularParams)
    }

    if (includeHashParams(mode)) {
        addParamsFromString(result, splitted.hashParams)
    }

    return result
}


function split (url) {
    let hashSplit  = url.split("#")
    let beforeHash = hashSplit[0]
    let questionMarkSplit = beforeHash.split("?")
    return {
        mainUrl:       questionMarkSplit[0],
        regularParams: questionMarkSplit[1],
        hashParams:    hashSplit[1]
    }
}


function includeParams (mode) {
    return mode === "params" || mode === "all"
}


function includeHashParams (mode) {
    return mode === "#" || mode === "all"
}





function pushStateAdd (params, options) {
    const url = extendUrlWithParams(document.location.href, params, options)
    pushState(url)
}


function pushStateRemove (paramKeys, options) {
    const url = removeParamsFromUrl(document.location.href, paramKeys, options)
    pushState(url)
}


function pushStateReplace (params, options) {
    const url = extendUrlWithParams(window.location.pathname, params, options)
    pushState(url)
}


function pushState (url) {
    if (document.location.href !== url) {
        window.history.pushState(urlParams(url), document.title, url)
    }
}


function addParamsFromString (result, string) {
    if (!string) {
        return
    }

    let keysValues = string.split("&")

    keysValues.forEach(function (keyValue) {
        let [key, value] = keyValue.split("=")
        addKeyAndValue(result, key, parse(key, value))
    })
}


function addKeyAndValue (params, key, value) {
    const structured = key.match(/(\w+)\[(.*)\]/)
    if (structured) {
        const keyStart       = structured[1]
        const insideBrackets = structured[2]
        if (insideBrackets) {
            addObjectLiteralParam(params, {keyStart, insideBrackets, value})
        } else {
            addArrayParam(params, key, value)
        }
    } else {
        params[key] = value
    }
}


function addObjectLiteralParam (params, {keyStart, insideBrackets, value}) {
    if (!(keyStart in params)) {
        params[keyStart] = {}
    }

    if (insideBrackets.indexOf("]") > 0) {
        insideBrackets = `${insideBrackets.replace("]", "")}]`
    }

    addKeyAndValue(params[keyStart], insideBrackets, value)
}


function addArrayParam (params, key, value) {
    if (!(key in params)) {
        params[key] = []
    }
    params[key].push(value)
}


function parse (key, value) {

    if (typeof value === "undefined") {
        return null
    }

    value = betterDecodeUriComponent(value)

    let number = Number(value)
    if (String(number) === value) {
        value = number
    }

    if (value === "true") {
        return true
    }

    if (value === "false") {
        return false
    }

    return value
}



function extendUrlWithParams (url, params, options = {}) {
    if (Object.keys(params).length === 0) {
        return url
    }

    url = betterDecodeUriComponent(url)

    let splitted = split(url)
    let result   = `${encodeURI(splitted.mainUrl)}?`

    if (splitted.regularParams) {
        let currentParams = {}
        addParamsFromString(currentParams, splitted.regularParams)
        params = mergeParams(currentParams, params)
    }

    let paramsString = paramsToUrlString(params, options)

    if (paramsString) {
        result += paramsString
    }

    if (splitted.hashParams) {
        result += `#${splitted.hashParams}`
    }

    return result
}


function removeParamsFromUrl (url, paramKeys, options = {}) {
    paramKeys = arrayify(paramKeys)

    url = decodeURIComponent(url)
    let splitted = split(url)

    let currentParams = {}
    addParamsFromString(currentParams, splitted.regularParams)

    let paramsToKeep = {}

    let somethingToRemove = false
    for (let key in currentParams) {
        if (paramKeys.indexOf(key) === -1) {
            paramsToKeep[key] = currentParams[key]
        } else {
            somethingToRemove = true
        }
    }

    if (!somethingToRemove) {
        return url
    }


    let result = splitted.mainUrl

    let paramsString = paramsToUrlString(paramsToKeep, options)

    if (paramsString) {
        result += `?${paramsString}`
    }

    if (splitted.hashParams) {
        result += `#${splitted.hashParams}`
    }

    return result
}



function arrayify (param) {
    if (Array.isArray(param)) {
        return param
    } else {
        return [param]
    }
}


function paramsToUrlString (params, options = {}) {
    let result = []
    for (let key in params) {
        let value = params[key]
        if (key.endsWith("[]")) {
            key = key.substring(0, key.length - 2)
        }
        prepareParamForUrl(result, {key, value}, options)
    }
    return result.join("&")
}


function prepareParamForUrl (result, {key, value}, options) {
    let formatMethod
    if (Array.isArray(value)) {
        formatMethod = prepareArrayParamForUrl
    } else if (typeof value === "object") {
        formatMethod = prepareObjectParamForUrl
    } else {
        formatMethod = prepareSimpleParamForUrl
    }
    formatMethod(result, {key, value}, options)
}


function prepareSimpleParamForUrl (result, {key, value}, {ignoreEmptyParams}) {
    if (value === "" && ignoreEmptyParams) {
        return
    }
    result.push(`${betterEncodeUriComponent(key)}=${betterEncodeUriComponent(value)}`)
}


function prepareArrayParamForUrl (result, {key, value}, {useCommaForArrays}) {
    if (useCommaForArrays) {
        result.push(`${betterEncodeUriComponent(key)}=${value.map(betterEncodeUriComponent).join(",")}`)
    } else {
        let encodedKey = betterEncodeUriComponent(`${key}[]`)
        value.forEach((subValue) => {
            result.push(`${encodedKey}=${betterEncodeUriComponent(subValue)}`)
        })
    }
}


function prepareObjectParamForUrl (result, {key, value}, options) {
    for (let subKey in value) {
        const subValue = value[subKey]
        if (subKey.endsWith("[]")) {
            subKey = subKey.substring(0, subKey.length - 2)
        }
        let encodedKey = `${key}[${betterEncodeUriComponent(subKey)}]`
        prepareParamForUrl(result, {key: encodedKey, value: subValue}, options)
    }
}




function mergeParams (currentParams, newParams) {
    let result = {}

    for (let key in currentParams) {
        result[key] = currentParams[key]
    }

    for (let key in newParams) {
        let value = newParams[key]
        if ((`${key}[]`) in currentParams && value === null) {
            delete result[`${key}[]`]
        } else {
            addKeyAndValue(result, key, value)
        }
    }

    return result
}


function betterDecodeUri (string) {
    return decodeURI(string.replace(/\+/g, " "))
}


function betterDecodeUriComponent (string) {
    return decodeURIComponent(string.replace(/\+/g, " "))
}


function betterEncodeUriComponent (string) {
    return encodeURIComponent(string).replace(/%20/g, "+")
}


function isEmpty () {
    return Object.keys(urlParams()).length === 0
}


urlParams.pushStateAdd        = pushStateAdd
urlParams.pushStateRemove     = pushStateRemove
urlParams.pushStateReplace    = pushStateReplace
urlParams.extendUrlWithParams = extendUrlWithParams
urlParams.removeParamsFromUrl = removeParamsFromUrl
urlParams.paramsToUrlString   = paramsToUrlString
urlParams.addParamsFromString = addParamsFromString
urlParams.isEmpty             = isEmpty

export default urlParams
